import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";
import { myAxios, getCurrentWeekRange } from "src/components/common/functions";
import { appendField } from "../common/FilterFrame/FilterField";
import { fields } from "./BillingFilterForm";
import { buildDefaultState } from "../common/FilterFrame/FilterModal";
import { extraFields } from "./billings";

export async function billingsLoader({ request }: LoaderFunctionArgs) {
    const url = new URL(request.url);
    const pageParam  = url.searchParams.get("page");
    const limitParam = url.searchParams.get("limit");
    const week = getCurrentWeekRange();
    const startParam = url.searchParams.get("createdAtFrom");
    const endParam = url.searchParams.get("createdAtTo");
    let shouldRedirect = false;
    for (const [key] of url.searchParams) {
        if(![...Object.keys(buildDefaultState(fields)), ...extraFields].includes(key)){
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }
    if (!pageParam) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!limitParam) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    if (!startParam) {
        url.searchParams.set("createdAtFrom", week.start);
        shouldRedirect = true;
    }
    if (!endParam) {
        url.searchParams.set("createdAtTo", week.end);
        shouldRedirect = true;
    }
    if (shouldRedirect) throw redirect(url.pathname + "?" + url.searchParams.toString());
    const page  = Number(url.searchParams.get("page"));
    const limit = Number(url.searchParams.get("limit"));
    const fd = new FormData();
    fd.append("page", String(page));
    fd.append("limit", String(limit));
    for (const field of fields) {
        appendField(fd, url.searchParams, field);
    }
    const billingsRes = await myAxios({ fileName: "billings/readBillings.php", formData: fd });
    if(!billingsRes) throw redirect("..");
    return billingsRes.data;

}

export async function billingLoader({ params }: LoaderFunctionArgs) {
    const id = params.id;
    if (!id) {
        throw redirect("/Billings");
    }
    const formData = new FormData();
    formData.append("id", id);
    const res = await myAxios({ fileName: "billings/readBilling.php", formData });
    if (!res || !res.data) {
        throw redirect("/Billings");
    }
    return res.data;
}

const billingUrlMap = {
    Add: "billings/createBilling.php",
    Edit: "billings/updateBilling.php",
};

export async function billingAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const action = String(formData.get("action") ?? "");
    const apiPath = billingUrlMap[action as keyof typeof billingUrlMap];
    if (!apiPath) {
        window.alert("Invalid billing action.");
        return null;
    }
    if (!formData.get("projectId")) {
        window.alert("Please select a project.");
        return null;
    }
    if (!formData.get("approverId")) {
        window.alert("Please select an approver.");
        return null;
    }

    const validationRes = await myAxios({
        fileName: "billings/validate.php",
        formData,
        signal: controller.signal,
    });
    if (!validationRes) return null;

    const billingNumber = String(formData.get("billingNumber") ?? "");
    const fromDate = String(formData.get("fromDate") ?? "");
    const toDate = String(formData.get("toDate") ?? "");
    const ranges = action === "Edit"
        ? (validationRes.data as { billingNumber: string; fromDate: string; toDate: string }[]).filter(
              range => range.billingNumber !== billingNumber
          )
        : ((validationRes.data as { billingNumber: string; fromDate: string; toDate: string }[]) ?? []);
    for (const range of ranges) {
        const before = toDate < range.fromDate;
        const after = fromDate > range.toDate;
        if (!(before || after)) {
            window.alert(`Time conflict with ${range.billingNumber}: ${range.fromDate} to ${range.toDate}`);
            return null;
        }
    }

    const res = await myAxios({
        fileName: apiPath,
        formData,
        signal: controller.signal,
    });
    if (!res) return null;

    if (action === "Add") {
        return redirect(`/Billings/${res.data.id}`);
    }
    return redirect("..");
}

export async function billedAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const url = new URL(request.url);
    const formData = await request.formData();
    if (!formData.get("id")) {
        throw new Response("Missing billing id", { status: 400 });
    }
    const res = await myAxios({
        fileName: "billings/billed.php",
        formData,
        signal: controller.signal,
    });
    if (!res) {
        throw redirect(`..?${url.searchParams.toString()}`);
    }
    throw redirect(`..?${url.searchParams.toString()}`);
}
